<template>
  <v-container class="mt-0 pt-0 pl-0 ptoContainer">
        <v-alert class="mb-10 ml-n3" v-if="who_delegated.length > 0"
          border="bottom"
          colored-border
          type="error"
          color="#ffb500"
          elevation="3"
        >
          Delegated access from: {{ this.who_delegated }}
        </v-alert>              

    <!-- Pending Requests --> 
    <v-row v-if="staff_pending_data.length > 0" class="mt-0 pt-0">
      <v-col class="mt-0 pt-0">
        <h3>Pending Requests</h3>
        <v-container>
          <v-layout row wrap pb-0>
            <v-flex xs12 md2 class="font-weight-bold hidden-sm-and-down">Requester</v-flex>
            <v-flex xs12 md2 class="font-weight-bold hidden-sm-and-down">Type</v-flex>
            <v-flex xs12 md2 class="font-weight-bold hidden-sm-and-down">Date</v-flex>
            <v-flex xs12 md2 class="font-weight-bold hidden-sm-and-down">Duration</v-flex>
            <v-flex xs12 md2 class="font-weight-bold hidden-sm-and-down">Manager Approval</v-flex>
            <v-flex xs12 md2 >
              <v-checkbox
                v-model="approveAll"
                class="mt-0 mb-0 pb-0 pt-0 font-regular checkbox-padding"
                :label="`Approve All`"
                id="approveAll"
                value
              @change="approve_all"
              ></v-checkbox> 
            </v-flex>
          </v-layout>
          <!--
          <v-divider></v-divider>
            -->

          <v-form ref="pto_form" lazy-validation>
            <v-card
              flat
              v-for="pending in staff_pending_data.slice().reverse()"
              :key="pending.info"
            >
              <v-layout row wrap pt-2 pb-2 class="layout">
                <v-flex xs12 md2>{{ pending.name }}</v-flex>
                <v-flex xs12 md2>{{ pending.pto_type }}</v-flex>
                <v-flex xs12 md2>{{ pending.req_date }}</v-flex>
                <v-flex xs12 md2>{{ pending.day_type }}</v-flex>
                <v-flex xs12 md4>
                  <v-btn
                    value="approve"
                    v-bind:info="pending.info"
                    v-bind:id="pending.info + '_approve'"
                    class="subtitle-2"
                    @click="selectApprDeny"
                  >
                    Approve
                  </v-btn>
                  <v-btn
                    value="deny"
                    v-bind:info="pending.info"
                    v-bind:id="pending.info + '_deny'"
                    class="subtitle-2"
                    @click="selectApprDeny"
                  >
                    Deny
                  </v-btn>
                  <div
                    class="form-group"
                    v-for="(input, k) in p_inputs"
                    :key="k"
                  >
                    <div
                      v-if="input.info == pending.info"
                      v-bind:id="pending.info"
                      style="display: none"
                      class="pt-2 reasons"
                    >
                      Deny reason: <br />
                      <v-text-field
                        v-model="input['comments']"
                        aria-label="Deny reason:"
                        outlined
                        dense
                        required
                        counter
                        maxlength="200"
                        :rules="[commentRules.required, commentRules.counter]"
                        class="messages"
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
              <!--
              <v-divider></v-divider>
              -->
            </v-card>

            <v-row class="submit-row">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  color="#FFB500"
                  depressed
                  @click="submitPto"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <div class="text-center">
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">
                  {{ dialog_title }}
                </v-card-title>
                <v-card-text>{{ dialog_text }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDialog(dialog_type)"
                  >
                    {{ dialog_ok }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-container>
      </v-col>
    </v-row>

    <!-- Share Access -->
    <PtoDelegate v-if="this.ptoInfo['showDelegateForm']" />

    <!-- Report for your team -->
    <v-row class="mt-0 pt-0 ml-n6">
      <v-col class="mt-0 pt-0">
        <h3 class="mb-0">Your Team's PTO </h3>

        <p v-if="staff_data.length > 0">
          Please select the name of your direct-reports to view their time off
          report.
        </p>
        <div v-if="staff_data.length <= 0"><br><br>No PTO requested</div>
        
        <div v-if="site_status!='cur_year_only'">
          <v-tabs show-arrows>
            <v-tabs-slider color="#ffb500"></v-tabs-slider>
              <v-tab class="font-weight-bold black--text" v-if="ptoInfo['showBalPrevTab']" v-on:click="show_hide_content('show_prev')">{{this.prev_yr_str}} Report</v-tab>
              <v-tab class="font-weight-bold black--text" v-if="ptoInfo['showReqBalTab']" v-on:click="show_hide_content('show_cur')">{{this.cur_yr_str}} Report</v-tab>
              <v-tab class="font-weight-bold black--text" v-if="ptoInfo['showBalNextTab']" v-on:click="show_hide_content('show_next')">{{this.next_yr_str}} Report</v-tab>      
          </v-tabs>
        </div>

        <div>
          <v-expansion-panels multiple flat>
            <v-expansion-panel v-for="(staff, i) in staff_data" :key="i">
              <v-expansion-panel-header v-if="staff.name">{{
                staff.name
              }}<span v-if="staff.cw_opt_in && ptoInfo['showCompWeekInfo']" class="cw_span">Compressed Day: {{ staff.cw_day }} </span></v-expansion-panel-header>

              <v-expansion-panel-content v-for="(pto_info, h) in staff.pto" :key="h">
                <div  v-if="staff.pto[h].length <= 0" class="pl-8 pt-2 pb-2">
                  <!-- No PTO Request -->
                  <div v-if="(staff.pto[h]['no_req_css_class'] == 'cur_yr_content' && !hide_cur_yr_content) || (staff.pto[h]['no_req_css_class'] == 'next_yr_content' && !hide_next_yr_content)">
                      No PTO requested
                  </div>
                </div>
                <!-- All PTO Requests -->
                <div v-else v-for="(pto, j) in pto_info" :key="j"> 
                  <div v-if="(pto.css_class == 'cur_yr_content' && !hide_cur_yr_content) || (pto.css_class == 'next_yr_content' && !hide_next_yr_content) || (pto.css_class == 'prev_yr_content' && !hide_prev_yr_content)">
                    <div v-if="pto.cat_name.toLowerCase() != 'covid sick days'">      
                      <v-layout row wrap class="staff_pto pt-2 pb-2 t_head">
                        <v-flex xs12 md12 class="font-weight-medium staff_pto_col"
                            >{{ pto.cat_name }}</v-flex
                        >
                      </v-layout>
                  <v-layout v-if="pto.carryOver > 0" row wrap class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Carried Over
                      <span class="float-right pr-12">{{ pto.carryOver }}</span>
                    </v-flex>
                  </v-layout>                        
                  <v-layout v-if="pto.limit >= 0" row wrap class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Limit
                      <span class="float-right pr-12">{{ pto.limit }}<span v-if="pto.cat_name.toLowerCase() == 'prenatal care'">h</span></span>
                    </v-flex>
                  </v-layout>                    
                  <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-if="pto.taken.length > 0">
                    <v-flex xs12 md4 class="staff_pto_col">Taken</v-flex>
                    <v-flex xs12 md8 class="staff_pto_col">
                        <span v-for="(taken, k) in pto.taken" :key="k">
                        <v-tooltip left v-if="taken.status">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="is_NYPFL( taken.day_type )"
                              class="icon-circle-green"
                              aria-label="NYPFL"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-minus-circle</v-icon
                            >
                            <v-icon
                              v-else-if="taken.status == 'Confirmed'"
                              class="icon-circle-green"
                              aria-label="Employee Confirmed"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span v-if="is_NYPFL( taken.day_type )"
                            >NYPFL</span
                          >
                          <span v-else-if="taken.status == 'Confirmed'"
                            >Employee Confirmed</span
                          >
                          <span v-else>Pending Employee Confirmation</span>
                        </v-tooltip> 
                            {{taken.req_date }} -  <span v-if="is_NYPFL( taken.day_type )" class="day_type_nypfl"></span><span v-else>{{ taken.day_type}}</span> 
                            <span v-if="k == 0" class="float-right pr-12">{{ pto.taken_total }}<span v-if="pto.cat_name.toLowerCase() == 'prenatal care'">h</span> </span><br>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-if="pto.scheduled.length > 0">
                    <v-flex xs12 md4 class="staff_pto_col">Scheduled</v-flex>
                    <v-flex xs12 md8 class="staff_pto_col">
                        <span v-for="(scheduled, l) in pto.scheduled" :key="l">
                        <v-tooltip left v-if="scheduled.status">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                scheduled.status == 'Confirmed'
                              "
                              class="icon-circle-green"
                              aria-label="NYPFL or Disability"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-minus-circle</v-icon
                            >
                            <v-icon
                              v-else-if="
                                scheduled.status == 'Approved'
                              "
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Manager Approval"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span
                            v-if="scheduled.status == 'Confirmed'"
                            >NYPFL or Disability</span
                          >
                          <span
                            v-else-if="
                              scheduled.status == 'Approved'
                            "
                            >Pending Employee Confirmation</span
                          >
                          <span v-else>Pending Manager Approval</span>
                        </v-tooltip> 
                            {{scheduled.req_date }} -  <span v-if="is_NYPFL( scheduled.day_type )" class="day_type_nypfl"></span><span v-else>{{ scheduled.day_type}}</span> 
                            <span v-if="l == 0" class="float-right pr-12">{{ pto.scheduled_total }}<span v-if="pto.cat_name.toLowerCase() == 'prenatal care'">h</span></span> <br>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="pto.remaining >= 0" class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Remaining
                      <span class="float-right pr-12">{{ pto.remaining }}<span v-if="pto.cat_name.toLowerCase() == 'prenatal care'">h</span></span>
                    </v-flex>
                  </v-layout>
                  <div v-if="afterCreated && pto.denied_disputed && pto.denied_disputed.length > 0" >
                    <v-layout row wrap class="staff_pto pt-2 pb-2 tr">
                      <v-flex xs12 md4 class="staff_pto_col" >
                        Type: </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                        Date: 
                      </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                       Reason:
                      </v-flex>
                    </v-layout>         
                    <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-for="(denied_disputed, x) in pto.denied_disputed" :key="x">
                      <v-flex xs12 md4 class="staff_pto_col" >
                        {{ denied_disputed.type }}</v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                        {{ denied_disputed.date }}
                      </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                       {{ denied_disputed.reason }}
                      </v-flex>
                    </v-layout>
                  </div>
                      </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>

    <!-- ORIGINAL....
    <v-row class="mt-0 pt-0 ml-n6">
      <v-col class="mt-0 pt-0">
        <h3 class="mb-0">Your Team's PTO</h3>
        <p v-if="staff_data.length > 0">
          Please select the name of your direct-reports to view their time off
          report.
        </p>
        <div v-if="staff_data.length <= 0"><br><br>No PTO requested</div>
        <div>
          <v-expansion-panels multiple flat>
            <v-expansion-panel v-for="(staff, i) in staff_data" :key="i">
              <v-expansion-panel-header v-if="staff.name">{{
                staff.name
              }}</v-expansion-panel-header>

              <v-expansion-panel-content v-if="staff.pto.length <= 0">
                <div class="pl-8 pt-2 pb-2">No PTO requested</div></v-expansion-panel-content>

              <v-expansion-panel-content v-for="(pto, j) in staff.pto" :key="j">
                <div v-if="pto.cat_name.toLowerCase() != 'covid sick days'">      
                  <v-layout row wrap class="staff_pto pt-2 pb-2 t_head">
                    <v-flex xs12 md12 class="font-weight-medium staff_pto_col"
                      >{{ pto.cat_name }}</v-flex
                    >
                  </v-layout>
                  <v-layout v-if="pto.carryOver > 0" row wrap class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Carried Over
                      <span class="float-right pr-12">{{ pto.carryOver }}</span>
                    </v-flex>
                  </v-layout>                        
                  <v-layout v-if="pto.limit >= 0" row wrap class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Limit
                      <span class="float-right pr-12">{{ pto.limit }}</span>
                    </v-flex>
                  </v-layout>                    
                  <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-if="pto.taken.length > 0">
                    <v-flex xs12 md4 class="staff_pto_col">Taken</v-flex>
                    <v-flex xs12 md8 class="staff_pto_col">
                        <span v-for="(taken, k) in pto.taken" :key="k">
                        <v-tooltip left v-if="taken.status">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="taken.status == 'Confirmed'"
                              class="icon-circle-green"
                              aria-label="Employee Confirmed"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span v-if="taken.status == 'Confirmed'"
                            >Employee Confirmed</span
                          >
                          <span v-else>Pending Employee Confirmation</span>
                        </v-tooltip> 
                            {{taken.req_date }} - {{ taken.day_type}} 
                            <span v-if="k == 0" class="float-right pr-12">{{ pto.taken_total }} </span><br>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-if="pto.scheduled.length > 0">
                    <v-flex xs12 md4 class="staff_pto_col">Scheduled</v-flex>
                    <v-flex xs12 md8 class="staff_pto_col">
                        <span v-for="(scheduled, l) in pto.scheduled" :key="l">
                        <v-tooltip left v-if="scheduled.status">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                scheduled.status == 'Confirmed'
                              "
                              class="icon-circle-green"
                              aria-label="Employee Confirmed"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon
                              v-else-if="
                                scheduled.status == 'Approved'
                              "
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Manager Approval"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span
                            v-if="scheduled.status == 'Confirmed'"
                            >Employee Confirmed</span
                          >
                          <span
                            v-else-if="
                              scheduled.status == 'Approved'
                            "
                            >Pending Employee Confirmation</span
                          >
                          <span v-else>Pending Manager Approval</span>
                        </v-tooltip> 
                            {{scheduled.req_date }} - {{ scheduled.day_type}}
                            <span v-if="l == 0" class="float-right pr-12">{{ pto.scheduled_total }} </span> <br>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="pto.remaining >= 0" class="staff_pto pt-2 pb-2 tr">
                    <v-flex xs12 md12 class="staff_pto_col">Remaining
                      <span class="float-right pr-12">{{ pto.remaining }}</span>
                    </v-flex>
                  </v-layout>
                  <div v-if="afterCreated && pto.denied_disputed && pto.denied_disputed.length > 0" >
                    <v-layout row wrap class="staff_pto pt-2 pb-2 tr">
                      <v-flex xs12 md4 class="staff_pto_col" >
                        Type: </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                        Date: 
                      </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                       Reason:
                      </v-flex>
                    </v-layout>         
                    <v-layout row wrap class="staff_pto pt-2 pb-2 tr" v-for="(denied_disputed, x) in pto.denied_disputed" :key="x">
                      <v-flex xs12 md4 class="staff_pto_col" >
                        {{ denied_disputed.type }}</v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                        {{ denied_disputed.date }}
                      </v-flex>
                      <v-flex xs12 md4 class="staff_pto_col">
                       {{ denied_disputed.reason }}
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>
  -->
  </v-container>
</template>


<script>
import axios from "axios";
import pto_func from "@/pto_functions";
import PtoDelegate from "./PtoDelegate";
import moment from 'moment';

var today = pto_func.get_today_date();

export default {
  components: { PtoDelegate },

  props: ["ptoInfo"],

  data: () => ({
    pto_mgr_cat_mv: [],
    pto_mgr_cat_appr_mv: [],
    pto_mgr_cat_date: [],
    pto_mgr_cat_prefix: [],
    pto_mgr_cat_limit: [],
    pto_mgr_cat_carryOver: [],
    pto_mgr_cat_plurals: [],

    pto_data: [null],
    staff_pto_data: [],
    staff_pending_data: [],
    staff_data: [],

    p_inputs: [],
    approveAll: false,
    toggle_exclusive: [],
    toggle_states: [],
    site_status: pto_func.get_site_status(),
    cur_yr_str: pto_func.get_fiscal_year("cur_str_short"),
    next_yr_str: pto_func.get_fiscal_year("next_str_short"),
    prev_yr_str: pto_func.get_fiscal_year("prev_str_short"),

    cur_yr_long: pto_func.get_fiscal_year("cur_long"),

    commentRules: {
      required: (v) => !!v || "Deny Reason cannot be blank",
      counter: (v) => v.length <= 200 || "Max 200 characters",
    },

    dialog: false,
    dialog_title: "Alert!",
    dialog_ok: "OK",
    dialog_text: "",
    dialog_type: "",
    afterCreated: false,

    who_delegated: "",
    is_trainer: false,

    hide_cur_yr_content: false,
    hide_next_yr_content: true,
    hide_prev_yr_content: true,
  }),

  created() {
    this.pto_mgr_cat_mv = pto_func.getPtoCats("pto_mgr_mv");
    this.pto_mgr_cat_appr_mv = pto_func.getPtoCats("pto_mgr_appr_mv");
    this.pto_mgr_cat_date = pto_func.getPtoCats("pto_mgr_date");
    this.pto_mgr_cat_prefix = pto_func.getPtoCats("pto_mgr_prefix");
    this.pto_mgr_cat_limit = pto_func.getPtoCats("pto_mgr_limit");
    this.pto_mgr_cat_carryOver = pto_func.getPtoCats("pto_mgr_carryOver");
    this.pto_mgr_cat_plurals = pto_func.getPtoCats("plurals");
    this.pto_mgr_cat_codes = pto_func.getPtoCats("codes");

    let cat_name = "";
    let cat_full_name = "";
    let cat_code = "";
    let mv_name = "";
    let mv_array = [];
    let prefix = "";
    let req_date = "";
    let appr_date = "";
    let cfm_date = "";
    let day_type = "";
    let status = "";
    let info = "";
    //let tmp_pending_reqs = [];
    let tmp_req = [];
    //let tmp_pending_data = [];
    let p_count = 0;
    let tmp_pto = [];
    let tmp_pto_taken = [];
    let tmp_pto_scheduled = [];
    let tmp_cat = [];
    let tmp_mv = [];
    let tmp_pto_res = {};
    let limit = 0;
    let carryOver = 0;
    let taken_total = 0;
    let scheduled_total = 0;
    let remaining = 0;
    let day_num = 0.5;
    //let tmp_staff_data = [];
    let tmp_denied_disputed = [];
    //let reason = "";
    let tmp_staff_pref_name = "";
    let saas_id = null;
    let tmp_cw_day = "";
    let tmp_cw_opt_in = "";
    let fy = null;
    let staff_id = null;
    let next_idx = null;
    let next_staff_id = null;
    //let req_yr = null;
    let cur_yr = pto_func.get_fiscal_year("cur_long");
    let next_yr = pto_func.get_fiscal_year("next_long");
    let prev_yr = pto_func.get_fiscal_year("prev_long");
    let css_class = null;
    let no_req_css_class = null;
    let zero_out_co = false;  
    let startTime = 0;
    let endTime = 0;

    //if (this.site_status == "prev_and_cur_year" || this.site_status == "roll_data") {
    if (pto_func.show_prev_balance()) {  
      this.hide_cur_yr_content = true;
      this.hide_prev_yr_content = false;
    }

    axios.get("./remote-apis/pto_api.php?cmd=pto_trainer").then((response) => {
      if (response.data == null) {
          this.is_trainer = false;
          return;
      } else {
        this.is_trainer = response.data.is_trainer; 
      }
    }).catch(error => {
          window.console.error(error);
    }); 

    axios.get("./remote-apis/pto_api.php?cmd=pto_mgr_view").then((response) => {
      //this.staff_pto_data = response.data.ROOT.Directory_SS
      if (response.data.ROOT == null) {
        // manager has no staff?
      } else if (Array.isArray(response.data.ROOT.PTO)) {
        for (let i = 0; i < response.data.ROOT.PTO.length; i++) {
          this.staff_pto_data.push(response.data.ROOT.PTO[i]);
        }
      } else {
        this.staff_pto_data.push(response.data.ROOT.PTO);
      }

      // loop each staff:
      for (let i = 0; i < this.staff_pto_data.length; i++) {
        tmp_req = [];
        tmp_cat = [];
        tmp_mv = [];
        zero_out_co = false;  

        if (this.is_trainer == true) {
          tmp_staff_pref_name = pto_func.maskEmpName(this.staff_pto_data[i]["PREF.NAME"]);
        } else {
          tmp_staff_pref_name = this.staff_pto_data[i]["PREF.NAME"];
        }

        saas_id = this.staff_pto_data[i]["_ID"].split("*");
        fy = saas_id[0];
        staff_id = saas_id[1];

        //window.console.log("fy = " + fy + ", cur = " + cur_yr + ", next = " + next_yr + ", prev = " + prev_yr);
      
        // do not show carried over before data roll
        if (fy == next_yr && this.site_status == "cur_and_next_year") {
          zero_out_co = true;
        } else if (this.site_status == "prev_and_cur_year" || this.site_status == "roll_data")  {
          // before data roll, do not show carried over for current year
          if (fy == cur_yr)
            zero_out_co = true;
        }  

        if (fy == cur_yr) {
          no_req_css_class = "cur_yr_content";
          if (this.staff_pto_data[i]["COMPRESSED.DAY"])
            tmp_cw_day = this.staff_pto_data[i]["COMPRESSED.DAY"].charAt(0) + this.staff_pto_data[i]["COMPRESSED.DAY"].slice(1).toLowerCase() ;
          else
            tmp_cw_day = "";
          tmp_cw_opt_in = this.staff_pto_data[i]["COMPRESSED.OPTIN"] ;
        } else if (fy == next_yr) {
          no_req_css_class = "next_yr_content";
        } else if (fy == prev_yr) {
          no_req_css_class = "prev_yr_content";
        }
        
        //tmp_pending_data = [];
        // loop each category:
        for (let j = 0; j < this.pto_mgr_cat_mv.length; j++) {
          // mv names
          tmp_pto = [];
          tmp_pto_taken = [];
          tmp_pto_scheduled = [];
          cat_name = this.pto_mgr_cat_mv[j];
          cat_code = this.pto_mgr_cat_codes[j];
          cat_full_name = this.pto_mgr_cat_plurals[j];
          mv_array = [];
          mv_name = cat_name + ".REQUEST_MV";
          mv_array = this.staff_pto_data[i][mv_name];
          prefix = this.pto_mgr_cat_prefix[j];
          limit = 0;
          carryOver = 0;
          taken_total = 0;
          scheduled_total = 0;
          remaining = 0;        
          startTime = 0;
          endTime = 0;

          // mv_array has one requested or null, push it into an array
          if (Array.isArray(mv_array) == false) {
            // category that requires approval
            if (this.pto_mgr_cat_appr_mv.includes(cat_name)) {
              // format data as an array
              tmp_mv = {};
              tmp_mv[this.pto_mgr_cat_date[j]] =
                mv_array[this.pto_mgr_cat_date[j]];
              tmp_mv[prefix + ".DAY.TYPE"] = mv_array[prefix + ".DAY.TYPE"];
              tmp_mv[prefix + ".APPROVED.DATE"] =
                mv_array[prefix + ".APPROVED.DATE"];
              tmp_mv[prefix + ".CONFIRMED"] = mv_array[prefix + ".CONFIRMED"];
              mv_array = [];
              mv_array.push(tmp_mv);
            } else { 
              // category does not require approval
              if (mv_array[this.pto_mgr_cat_date[j]]) {
                tmp_mv = {};
                tmp_mv[this.pto_mgr_cat_date[j]] =
                  mv_array[this.pto_mgr_cat_date[j]];
                tmp_mv[prefix + ".TYPE"] = mv_array[prefix + ".TYPE"];
                tmp_mv[prefix + ".APPROVED.DATE"] = "";
                tmp_mv[prefix + ".CONFIRMED"] = "";
                mv_array = [];
                mv_array.push(tmp_mv);
              }
            }
          }

          // loop each mv:
          for (let k = 0; k < mv_array.length; k++) {
            tmp_req = [];
            req_date = this.setDateVal(mv_array[k][this.pto_mgr_cat_date[j]]);
            appr_date = this.setDateVal(mv_array[k][prefix + ".APPROVED.DATE"]);
            cfm_date = this.setDateVal(mv_array[k][prefix + ".CONFIRMED"]);

            if (!req_date)
              continue;

            // Set day_type, info and status value. 
            // Different naming convention for cat require approval vs not req approval.    
            if (this.pto_mgr_cat_appr_mv.includes(cat_name)) {
              // categories require manager approval:

              day_type = pto_func.formatDayType(mv_array[k][prefix + ".DAY.TYPE"], false);

              //window.console.log(tmp_staff_pref_name + " - " + cat_name + " >>>>>>>> " + day_type + ", orig: " + mv_array[k][prefix + ".DAY.TYPE"] );

              info =
                this.staff_pto_data[i]["ID.NO"] +
                "_" +
                mv_array[k][this.pto_mgr_cat_date[j]] +
                "_" +
                cat_name +
                "_" +
                day_type;
              status = pto_func.get_pto_status( 
                cat_code,
                mv_array[k][prefix + ".CONFIRMED"],
                mv_array[k][prefix + ".APPROVED.DATE"]
              );
            } else {
              if (cat_name == "PRENATAL")
                day_type = mv_array[k][prefix + ".START.TIME"] + " - " + mv_array[k][prefix + ".END.TIME"];
              else
                day_type = pto_func.formatDayType(mv_array[k][prefix + ".TYPE"], false);
              info = "";
              status = pto_func.get_pto_status( 
                cat_code,
                mv_array[k][prefix + ".CONFIRMED"],
                mv_array[k][prefix + ".APPROVED.DATE"]
              );
            }

            //day_num = 0.5;
            //if (day_type.toUpperCase() == "FULL")
            //  day_num = 1;
            if (cat_name == "PRENATAL") {
              startTime = moment(mv_array[k][prefix + ".START.TIME"], ['HH:mma', 'HH:mm:ss']) ;
              endTime = moment(mv_array[k][prefix + ".END.TIME"], ['HH:mma', 'HH:mm:ss']) ;
              day_num = endTime.diff(startTime, 'hours', true);
            } else {
              day_num = pto_func.full_partial_to_num(day_type); 
            }

            // populate taken and scheduled array
            if (req_date && req_date.getTime() < today.getTime()) {
                  tmp_pto_taken.push({
                    pto_type: cat_name,
                    req_date: mv_array[k][this.pto_mgr_cat_date[j]],
                    day_type: day_type,
                    status: status,
                });
                taken_total += day_num;
            } else {
                tmp_pto_scheduled.push({
                    pto_type: cat_name,
                    req_date: mv_array[k][this.pto_mgr_cat_date[j]],
                    day_type: day_type,
                    status: status,
                });
                scheduled_total += day_num;
            }

            // not really using it, just keep the code here...
            tmp_pto.push({
              pto_type: cat_name,
              req_date: mv_array[k][this.pto_mgr_cat_date[j]],
              day_type: day_type,
              status: status,
            });

            //req_yr = pto_func.get_fiscal_year("saas_date", mv_array[k][this.pto_mgr_cat_date[j]]);
            css_class = "cur_yr_content";
            /*
            if (req_yr == next_yr) 
              css_class = "next_yr_content";
            else if (req_yr == prev_yr)
              css_class = "prev_yr_content" ;
            */
            if (fy == next_yr) 
              css_class = "next_yr_content";
            else if (fy == prev_yr)
              css_class = "prev_yr_content" ;

            //window.console.log("req_yr = " + req_yr + ", ori: " + mv_array[k][this.pto_mgr_cat_date[j]]  );
              
            // combine everything together:
            tmp_req = {
              name: tmp_staff_pref_name,
              auid: this.staff_pto_data[i]["ID.NO"],
              pto_type: cat_name,
              req_date: mv_array[k][this.pto_mgr_cat_date[j]],
              appr_date: mv_array[k][prefix + ".APPROVED.DATE"],
              cfm_date: mv_array[k][prefix + ".CONFIRMED"],
              day_type: day_type,
              info: info,
            };

            // for categories that require approval
            if (this.pto_mgr_cat_appr_mv.includes(cat_name)) {
              // populate inputs for pending approval requests
              if (
                req_date !== null &&
                req_date.getTime() >= today.getTime() &&
                appr_date == null &&
                cfm_date == null
              ) {
                //tmp_pending_reqs.push(tmp_req);
                this.staff_pending_data.push(tmp_req);

                this.toggle_exclusive[p_count] = 0;
                this.toggle_states.push({
                  info: info,
                  value: "",
                });

                this.p_inputs.push({
                  info: info,
                  cfm_type: "",
                  comments: "",
                });
                p_count++;
              }
            }
          }

          // assign and calculate totals:
          if (this.pto_mgr_cat_appr_mv.includes(cat_name)) {          
            limit = pto_func.formatNum(this.staff_pto_data[i][this.pto_mgr_cat_limit[j]]);
            if (!zero_out_co)
              carryOver = pto_func.formatNum(this.staff_pto_data[i][this.pto_mgr_cat_carryOver[j]]);
            remaining = (limit + carryOver - taken_total - scheduled_total).toFixed(1);
          } else if (cat_name == "PRENATAL") {
            limit = pto_func.formatNum(this.staff_pto_data[i]['PRENATAL.LIMIT']);
            carryOver = -1;
            remaining = (limit - taken_total - scheduled_total).toFixed(1);          
          } else {
            limit = -1;
            carryOver = -1;
            remaining = -1;
          }
          
          if (tmp_pto.length > 0) {
            tmp_cat.push({
              cat_name: cat_full_name,
              limit: limit,
              carryOver: carryOver,
              remaining: remaining,
              taken_total: (taken_total ? taken_total.toFixed(1) : 0),
              scheduled_total: (scheduled_total ? scheduled_total.toFixed(1): 0),
              requests: tmp_pto,
              taken: tmp_pto_taken.slice().reverse(),
              scheduled: tmp_pto_scheduled.slice().reverse(),
              denied_disputed: [],
              css_class: css_class,
            });
          }
        }
        //window.console.log(tmp_cat);

        // Denied or Disputes
        tmp_denied_disputed = [];
        tmp_denied_disputed = this.populate_denied_disputed(this.staff_pto_data[i]["DENIED_MV"], "DENIED", tmp_denied_disputed);
        tmp_denied_disputed = this.populate_denied_disputed(this.staff_pto_data[i]["DISPUTE_MV"], "DISPUTE", tmp_denied_disputed);

      if (tmp_denied_disputed.length > 0) {
        tmp_cat.push({
              cat_name: "Denied and Disputed",
              limit: -1,
              carryOver: -1,
              remaining: -1,
              taken_total: 0,
              scheduled_total: 0,
              requests: [],
              taken: [],
              scheduled: [],
              denied_disputed: tmp_denied_disputed.slice().reverse(),
              css_class: css_class,
        });

      }
/*
        this.staff_data.push({
          auid: this.staff_pto_data[i]["ID.NO"],
          name: tmp_staff_pref_name,
          pto: tmp_cat,
        });
*/
        next_idx = i+1;
        if (this.staff_pto_data[next_idx]) 
          next_staff_id = this.staff_pto_data[next_idx]["ID.NO"];
        else
          next_staff_id = null;

        tmp_pto_res[fy] = tmp_cat;
        tmp_pto_res[fy]['no_req_css_class'] = no_req_css_class;

        if (!next_staff_id || staff_id != next_staff_id) {
          this.staff_data.push({
            auid: this.staff_pto_data[i]["ID.NO"],
            name: tmp_staff_pref_name,
            cw_opt_in: tmp_cw_opt_in,
            cw_day: tmp_cw_day,
            pto: tmp_pto_res,
          }); 
          tmp_pto_res = {};
          tmp_cw_opt_in = "";
          tmp_cw_day = "";
        }

      } // each staff

      this.afterCreated = true;

    }).catch(error => {
          window.console.error(error);
    });

    axios.get("./remote-apis/pto_api.php?cmd=pto_delegate_access").then((response) => {
      this.who_delegated = response.data.who_delegated.trim().replace(/\|\s*$/, "").replaceAll("|", ", ");
      if (this.who_delegated.length > 0 && this.is_trainer == true) {
          this.who_delegated = pto_func.maskEmpName(this.who_delegated);
      }
    }).catch(error => {
          window.console.error(error);
    }); 

  },

  mounted() {
  },

  methods: {
    show_hide_content (which) {
      this.hide_prev_yr_content = true;
      this.hide_cur_yr_content = true;
      this.hide_next_yr_content = true;
      if (which == "show_prev") {
        this.hide_prev_yr_content = false;
        return;
      }
      if (which == "show_cur") {
        this.hide_cur_yr_content = false;
        return;
      }
      if (which == "show_next") {
        this.hide_next_yr_content = false;
        return;
      }
        
    },

    setDateVal(date_val) {
      if (date_val == null) {
        return null;
      }
      return new Date(pto_func.formatSaasDate(date_val) + "T09:00:00.000Z");
    },

    approve_all() {

      var info = "";
      var appr_el = null;
      var deny_el = null;

      for (var i = 0; i < this.p_inputs.length; i++) {

        info = this.p_inputs[i].info;
        appr_el = document.getElementById(info + "_approve");
        deny_el = document.getElementById(info + "_deny");

        // css stuff
        appr_el.classList.remove("pto_btn_active");
        deny_el.classList.remove("pto_btn_active");

        // hide deny reason div and clear text field
        document.getElementById(info).style.display = "none";
        this.p_inputs[i]["comments"] = "";
        this.p_inputs[i]["cfm_type"] = "";

        if (this.approveAll == true) {
          this.p_inputs[i]["cfm_type"] = "approve";
          appr_el.classList.add("pto_btn_active");
        }
      }
    },


    selectApprDeny(e) {
      var id = e.currentTarget.getAttribute("id");
      var action = e.currentTarget.value;
      var element = document.getElementById(id);
      var info = e.currentTarget.getAttribute("info");
      var appr_el = document.getElementById(info + "_approve");
      var deny_el = document.getElementById(info + "_deny");
      var isActive = element.classList.contains("pto_btn_active");
      var cfm_type = "";
      var reset_comments = false;

      // css stuff
      appr_el.classList.remove("pto_btn_active");
      deny_el.classList.remove("pto_btn_active");

      this.approveAll = false;

      if (
        action == "deny" &&
        document.getElementById(info).style.display == "none"
      ) {
        // clicked deny, show input fields.
        document.getElementById(info).style.display = "";
        element.classList.add("pto_btn_active");
        cfm_type = "deny";
      } else {
        // approve or click deny again
        // reset input fields
        reset_comments = true;
        /*
                for (var i = 0; i < this.p_inputs.length; i++) {
                    // Reset input fields
                    if (this.p_inputs[i]["info"] == info) {
                        this.p_inputs[i]["comments"] = "";
                        break;
                    }
                }
                   */
        if (action == "approve" && !isActive) {
          element.classList.add("pto_btn_active");
          cfm_type = "approve";
        } else {
          // click on approve or deny again, reset value
          cfm_type = "";
        }

        // hide input fields
        document.getElementById(info).style.display = "none";
      }

      for (var i = 0; i < this.p_inputs.length; i++) {
        if (this.p_inputs[i]["info"] == info) {
          if (reset_comments) this.p_inputs[i]["comments"] = "";
          this.p_inputs[i]["cfm_type"] = cfm_type;
          break;
        }
      }
    },


    submitPto() {
      if (this.hasSubmitError()) return false;

      axios
        .post("./remote-apis/ptoApprove.php", {
          formData: JSON.stringify(this.p_inputs),
          action: JSON.stringify("mgrApprove"),
        })
        .then((res) => {
          if (res.data.response == "OK") {
            this.dialog_title = "Thank you!";
            this.dialog_text = "Data has been saved.";
            this.dialog_type = "success";
            this.dialog = true;
          } else if (res.data.response == "FAILURE") {
            this.dialog_title = "Alert!";
            if (res.data.message) this.dialog_text = res.data.message;
            else
              this.dialog_text =
                "Cannot process your request. Please try again later.";
            this.dialog_type = "failure";
            this.dialog = true;
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },

    hasSubmitError() {
      var selectedAction = false;
      for (var i = 0; i < this.p_inputs.length; i++) {
        /*
        if (!this.p_inputs[i]["cfm_type"]) {
          this.dialog_text =
            "All requests must be approved or denied.";
          this.dialog_type = "error";
          this.dialog = true;
          return true;
        }*/
        if (
          this.p_inputs[i]["cfm_type"] == "deny" &&
          !this.p_inputs[i]["comments"]
        ) {
          this.dialog_text = "Deny Reason cannot be blank.";
          this.dialog_type = "error";
          this.dialog = true;
          return true;
        }
        if (this.p_inputs[i]["cfm_type"]) {
          selectedAction = true;
        }
      }

      if (selectedAction == false) { 
          this.dialog_text = "Please approve or deny at least one request.";
          this.dialog_type = "error";
          this.dialog = true;
          return true;
      }

      return false;
    },

    closeDialog() {
      this.dialog = false;

      if (this.dialog_type == "success") {
        window.location.reload();
        /*
        this.$router.push({
          path: "/pto/manager",
        }); */
      }
    },

    populate_denied_disputed(mv, type, tmp_denied_disputed) {
    
      let reason = "";
      let type_name = type;
      let date_name = type + ".DATE";

      if (type == "DISPUTE") {
        type_name = "DISPUTED";
        date_name = "DISPUTED.DATES";
      }

      // MV is null or contain only one set of data
      if (Array.isArray(mv) == false) {
          if (mv[date_name]) {
              if (mv[type + ".REASON"])
                reason = mv[type + ".REASON"];
              else
                reason = "";

            tmp_denied_disputed.push({
              type: type_name,
              date: mv[date_name],
              reason: reason
            });
          }
        } else {
        for (var x = 0; x < mv.length; x++) {
          if (mv[x][date_name]) {
              if (mv[x][type + ".REASON"])
                reason = mv[x][type + ".REASON"];
              else
                reason = "";

            tmp_denied_disputed.push({
              type: type_name,
              date: mv[x][date_name],
              reason: reason
            });
          }
        }

        }

    return tmp_denied_disputed;

    },

    is_NYPFL (dayType) {
      return pto_func.is_NYPFL(dayType);
    }

  },

  updated: function () {
    let reason_ids = document.getElementsByClassName("reasons");
    let tmp_id = "" ;
    for (var i = 0; i < reason_ids.length; i++) {
      tmp_id = reason_ids[i].getAttribute("id") ;
      if (document.getElementById(tmp_id + "_deny") && document.getElementById(tmp_id + "_deny").classList.contains('pto_btn_active')) {
          document.getElementById(tmp_id).style.display = "";
      } else {
          document.getElementById(tmp_id).style.display = "none";
      }
    }    
  }, 

};
</script>

<style scoped>
h3 {
  font-size: 25px;
  line-height: 1.29167em;
  font-family: "Graphik", Arial, Helvetica, sans-serif;
  font-weight: 500 !important;
  margin: 0 0 0.8em 0;
  color: #4f2c1d !important;
}

.ptoContainer {
  margin-left: -12px !important;
  margin-top: -20px !important;
}

.pto_btn_active {
  background-color: #7a6855 !important;
  color: #ffffff;
}

.v-application--is-ltr .v-expansion-panel-header {
  border-bottom: 1px solid #ffb500 !important;
}

.layout {
  border-bottom: 1px solid #ffb500 !important;
}

.staff_pto {
  border-bottom: 1px solid #eee !important;
}
/*
.staff_pto_col {
    border-bottom: none !important;
}
*/
.staff_pto_col {
  padding-left: 28px;
}

.icon-circle-gray {
  background: #bbb;
  padding: 2px;
  border-radius: 50%;
}

.icon-circle-green {
  color: green;
}

.icon-white {
  color: #fff;
  font-size: 1.1em;
}

.t_head,
.tr {
  margin-left: 1px;
  margin-right: 1px;
}

.t_head {
  background-color: #eee;
}

.tr:nth-child(even) {background: #fff }
.tr:nth-child(odd) {background: #f8f8f8 }
.tr:last-child {border-bottom: 0 !important }

.tr {
  padding-left: 18px;
  padding-right: 18px;
}

::v-deep .font-regular .v-label {
  font-weight: 400 !important;
}

.checkbox-padding {
  padding-left: 30px;
}

.cw_span {
  font-size: 14px; 
  font-weight: 0.5em; 
  text-align: right; 
  font-weight: 400; 
  font-style: italic; 
  padding-right: 18px; 
  text-transform: none; 
}

.day_type_nypfl::before {
      content: "\2153"; /* Unicode for 1/3 */
      font-size: 18px;
      color: #000;
    }

@media (max-width: 960px) {
  .checkbox-padding {
    padding-left: 0px;
  }
}

@media (min-width: 1264px) {
  .container {
      max-width: 1185px;
  }
}

</style>